import { Component } from "@angular/core";
import { NavController, NavParams, ModalController, ViewController } from "ionic-angular";
import { DomSanitizer} from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

import { DataProvider } from '../../providers/data/data';
import { CardProvider } from '../../providers/data/data';

@Component({
  selector: "page-process",
  templateUrl: "process.html"
})
export class ProcessPage {
  public url: any;
  private check: boolean = false;

  constructor(
    public http: HttpClient,
    private inAppBrowser: InAppBrowser,
    public navCtrl: NavController,
    private data: DataProvider,
    private card: CardProvider,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private sanitizer: DomSanitizer,
    public viewCtrl: ViewController
  ) {
    this.url = this.navParams.get('url');    
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  public ionViewDidEnter(): void {    
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = 'Process';
    if(this.navParams.get('type') == 'pdf') {
      document.getElementById('printBtn').style.display = 'block';
      this.check = true;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://drive.google.com/viewerng/viewer?embedded=true&print=true&url=" + this.navParams.get('url'));
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("http://docs.google.com/gview?url=" + this.navParams.get('url') + '&embedded=true');      
    } else if(this.navParams.get('type') == 'onlypdf') {
      document.getElementById('printBtn').style.display = 'none';
      this.check = true;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://drive.google.com/viewerng/viewer?embedded=true&print=true&url=" + this.navParams.get('url'));
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("http://docs.google.com/gview?url=" + this.navParams.get('url') + '&embedded=true');      
    } else {
      document.getElementById('printBtn').style.display = 'none';
    }
  }

  back() {
    //this.nav.popToRoot();
    this.viewCtrl.dismiss(null);
  }

  print(): Promise<any> {
    return new Promise(() => {
      const options: InAppBrowserOptions = {
        location : 'yes',
        hidden : 'no', 
        clearcache : 'yes',
        clearsessioncache : 'yes',
        zoom : 'yes',
        hardwareback : 'yes',
        mediaPlaybackRequiresUserAction : 'no',
        shouldPauseOnSuspend : 'no', 
        closebuttoncaption : 'Close',
        disallowoverscroll : 'no',
        toolbar : 'yes', 
        toolbarposition: 'bottom',
        footer: 'yes',
        enableViewportScale : 'no', 
        allowInlineMediaPlayback : 'no',
        presentationstyle : 'pagesheet',
        fullscreen : 'yes',
        sharebutton: 'yes',
        hideurlbar: 'no',
      };
      let browser = this.inAppBrowser.create(
        this.navParams.get('url'),
        // 'assets/myfile.pdf',
        '_system',
        options
      );
      browser.on('loadstop').subscribe(event => {
        browser.executeScript({code: "(function() { window.print(); })()"});
      });
      browser.on('loadstart').subscribe(event => {
        console.log('asdf');
        browser.executeScript({code: "(function() { window.print(); })()"});
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/process/process.ts